// Przycisk odświeżania danych z animacją i statusem

import React from "react";
import { useAccommodation } from "../../AccommodationProvider";

const RefreshButton: React.FC = () => {
  const { isLoading, refreshAvailability, lastRefreshed } = useAccommodation();

  const handleRefresh = () => {
    refreshAvailability();
  };

  return (
    <div className="flex items-center gap-3">
      {/* Timestamp ostatniej aktualizacji */}
      {lastRefreshed && !isLoading && (
        <span className="text-xs text-gray-500">
          Ostatnia: {lastRefreshed.toLocaleTimeString()}
        </span>
      )}

      {/* Przycisk odświeżania */}
      <button
        onClick={handleRefresh}
        disabled={isLoading}
        className={`
          flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg border transition-colors
          ${
            isLoading
              ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:text-gray-900"
          }
        `}
      >
        <span
          className={`text-base transition-transform ${
            isLoading ? "animate-spin" : "hover:rotate-45"
          }`}
        >
          🔄
        </span>
        <span>{isLoading ? "Odświeżam..." : "Odśwież"}</span>
      </button>
    </div>
  );
};

export default RefreshButton;
